module.exports = "<app-loading></app-loading>\r\n<router-outlet></router-outlet>"